if (!customElements.get('product-variant-recommendations')) {
  customElements.define(
    'product-variant-recommendations',
    class ProductVariantRecommendations extends ProductSection {
      constructor() {
        super();

        this.selectors = {
          ...this.selectors,
          variantContent: '[data-variant-content]'
        };

        this.data = {
          ...this.data,
          variantTitle: 'variantTitle'
        };

        this.attr = {
          ...this.attr,
          variantTitle: 'data-variant-title'
        };
        
      }

      productChangeUnsubscriber = undefined;
      productVariantChangeUnsubscriber = undefined;
      
      connectedCallback() {
        this.productChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.productChange, (event) => {
          const productHandle = event.data.productHandle;
          super.changeContent(productHandle);
          this.resetVariantContent();
        });

        if (this.querySelector(this.selectors.variantContent)) {
          this.productVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event.data.variant;
            this.changeVariantContent(variant);
          });
        }
      }

      disconnectedCallback() {
        if (this.productChangeUnsubscriber) {
          this.productChangeUnsubscriber.unsubscribe();
        }

        if (this.productVariantChangeUnsubscriber) {
          this.productVariantChangeUnsubscriber.unsubscribe();
        }
      }

      changeVariantContent(variant) {
        const currentContent = this.querySelector(`${this.selectors.content}.${this.classes.active}`);
        if (!currentContent?.querySelector(this.selectors.variantContent)) return;
        const currentVariantContent = currentContent.querySelector(`${this.selectors.variantContent}.${this.classes.active}`);
        const newVariantContent = currentContent.querySelector(`${this.selectors.variantContent}[${this.attr.variantTitle}="${variant?.title}"]`);
        const defaultVariantContent = currentContent.querySelector(`${this.selectors.variantContent}[${this.attr.variantTitle}="default"]`)

        if (currentVariantContent) currentVariantContent.classList.remove(this.classes.active);
        
        if (variant && newVariantContent) {
          newVariantContent.classList.add(this.classes.active);
          currentContent.classList.add(this.classes.active);
        } else if (defaultVariantContent) {
          defaultVariantContent.classList.add(this.classes.active);
          currentContent.classList.add(this.classes.active);
        }

        if (
          !newVariantContent &&
          !defaultVariantContent
        ) {
          currentContent.classList.remove(this.classes.active);
        }
        
      }

      resetVariantContent() {
        const mainProduct = document.querySelector('[id^="MainProduct-"]');
        const variantSelects = mainProduct.querySelector('variant-selects') || mainProduct.querySelector('variant-radios');
        if (!variantSelects) return;
        const currentVariant = variantSelects.getCurrentVariant();

        this.changeVariantContent(currentVariant);
      }
      
    }
  );
}
